($ => {
  Drupal.behaviors.header = {
    attach(context) {
      $('.current-language', context).click(e => {
        e.preventDefault();
        e.stopPropagation();
        const parentElement = $('.current-language').parent();
        if (parentElement.hasClass('open')) {
          parentElement.removeClass('open');
          $('body').off('.langselect');
        } else {
          parentElement.addClass('open');

          $('body').on('click.langselect', () => {
            parentElement.removeClass('open');
            $('body').off('.langselect');
          });
        }
      });
    },
  };

  Drupal.behaviors.mobileMenu = {
    attach(context) {
      $('.menu_block--hamburger', context).click(e => {
        $(e.currentTarget).toggleClass('open');
        $('.layout-container', context).toggleClass('open-mobile-menu-first');
        if ($(e.currentTarget).hasClass('open')) {
          $('.layout-container', context).addClass('open-mobile-menu');
          $('body', context).addClass('menuopen');
          $('html, body').animate({ scrollTop: 0 }, 'slow');
        } else {
          setTimeout(() => {
            $('.layout-container', context).removeClass('open-mobile-menu');
            $('body', context).removeClass('menuopen');
          }, 1000);
        }
      });
    },
  };
})(jQuery);
